import { gql } from "@apollo/client";

import {
  CAMPAIGN_WITH_CALLEE_FIELDS,
  CAMPAIGN_WITH_QUESTIONS
} from "./fragments";

export const EDIT_CAMPAIGN_QUESTIONS = gql`
  ${CAMPAIGN_WITH_CALLEE_FIELDS}
  ${CAMPAIGN_WITH_QUESTIONS}
  mutation campaignEditQuestions(
    $campaignId: ID!
    $questions: [CampaignQuestionInput!]!
  ) {
    campaignEditQuestions(
      id: $campaignId
      questions: { questions: $questions }
    ) {
      id
      ...CampaignWithQuestions
      ...CampaignWithCalleeFields
    }
  }
`;
